<template>
  <div>
    <CCard v-if="print">
      <CCardHeader>
        <strong>Analytic Report</strong>
      </CCardHeader>
      <CCardBody class="pt-0">
        <InformationTable
            :fields="field"
            :items="analyticReports"
            @deleteAnalyticReport="deleteAnalyticReport"
            @viewAnalyticReport="viewAnalyticReport"/>
      </CCardBody>
    </CCard>
    <analytic-report :results="results" @printPDF="printPDF" id="test" v-if="results.exam !== undefined"/>
  </div>
</template>

<script>
import InformationTable from "@/components/InformationTable";
import {mapGetters} from "vuex"
import AnalyticReport from "@/components/document/AnalyticReport";
import Service from "../service/api"

// import {jsPDF} from "jspdf"

export default {
  name: "MainAnalyticReport",
  components: {AnalyticReport, InformationTable},
  data() {
    return {
      field: [
        {key: "no", label: "No.", _style: "width: 3px"},
        {key: "name", label: "Name"},
        {key: "examSetNameAnalytic", label: "Exam Set"},
        {key: "createdAt", label: "Created At"},
        {key: "analyticOptions", label: "Option"}
      ],
      results: "",
      tempId: "",
      print: true
    }
  },
  mounted() {
    this.$store.dispatch("analyticReport/onSetAnalyticReports")
  },
  computed: {
    ...mapGetters({
      analyticReports: "analyticReport/analyticReports",
      actionStatus: "action/actionStatus"
    })
  },
  watch: {
    actionStatus(value) {
      if (value) {
        this.deleteAnalyticReportConfirmation()
      }
    },
  },
  methods: {
    printPDF() {
      this.print = false
      this.$store.commit("printPDF", true)
      setTimeout(() => {
        window.print()
        setTimeout(() => {
          this.print = true
          this.$store.commit("printPDF", false)
        }, 100)
      }, 200)
    },
    viewAnalyticReport(value) {
      Service.onFetchSingleAnalyticReports(value._id)
          .then(res => this.results = res.data.data)
          .catch(err => console.log(err))
    },
    deleteAnalyticReport(id) {
      this.tempId = id
      let body = {
        title: "Notification",
        color: "warning",
        status: true,
        text: "Do you really want to delete the report?"
      }
      this.$store.commit("modal/onSetConfirmActionModalStatus", body)
    },
    deleteAnalyticReportConfirmation() {
      this.$store.dispatch("analyticReport/onDeleteAnalyticReports", this.tempId)
    }
  }
}
</script>
